import React, { useState, useRef, useEffect } from "react";
import debounce from "lodash.debounce";
import { ConfigServer } from "../../data/config";

export const useGlobalSearch = () => {

  const [value, setValue] = useState("");
  const [resultsSearch, setResultsSearch] = useState([]);
  const controllerRef = useRef(null);

  const debouncedSearch = useRef(
    debounce(async (query, matchExact) => {

      if (!query || query.length < 3) {

        if (controllerRef.current) {
          controllerRef.current.abort();
        }

        setResultsSearch([
          {
            isMessage: true,
            message: "Escribe al menos 3 caracteres para buscar"
          }
        ]);
        return;
      }

      try {

        if (controllerRef.current) {
          controllerRef.current.abort();
        }

        controllerRef.current = new AbortController();

        const token = localStorage.getItem("token");

        const response = await fetch(`/api/WorkOrder/SearchGlobalWorkOrder?text=${query}&match_exact=${matchExact}`,
          {
            method: "GET",
            signal: controllerRef.current.signal,
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
          }
        );

        const data = await response.json();

        const grouped = data ?? [];

        let flat = [];

        grouped.forEach(group => {
          flat.push({
            isGroup: true,
            group_name: group.group_name,
            group_id: group.group_id,
            items: group.items
          });

          group.items.forEach(item => {
            flat.push({
              ...item,
              isGroup: false
            });
          });
        });

        if (flat.length === 0) {
          setResultsSearch([
            {
              isMessage: true,
              message: "Sin coincidencias encontradas"
            }
          ]);
          return;
        }

        setResultsSearch(flat);

      } catch (error) {

        // petición cancelada
        if (error.name === "AbortError") {
          console.log("petición cancelada");
          return;
        }

        console.log(error);

        setResultsSearch([]);
      }

    }, 400)
  ).current;

  const searchGlobal = (e, matchExact = false) => {
    const query = e?.query ?? value;

    debouncedSearch(query, matchExact);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();

      if (controllerRef.current) {
        controllerRef.current.abort();
      }

    };
  }, [debouncedSearch]);

  return {
    value,
    setValue,
    resultsSearch,
    searchGlobal,
  };
};
